enum Ownership {
  AllowAll,
  Resource,
  NFT,
  None,
}

export { Ownership };
